import {useUserStore} from "@/app/stores/user-store.ts";
import type {NavigationGuard, NavigationGuardReturn, RouteLocation} from "vue-router";
import {Payment} from "@/app/payment/payment-routes.ts";
import {Home} from "@/app/overview/overview-routes.ts";

export function createAuthGuard(): NavigationGuard {
    return async function (to: RouteLocation, from: RouteLocation): Promise<NavigationGuardReturn> {
        // requires login?
        if (to?.meta?.allowAnonymous) {
            return;
        }

        const redirectToLogin = () => {
            if (window) {
                const params = new URLSearchParams(window.location.search);
                const login_hint = params.get("login_hint");
                
                if (!!login_hint) {
                    window.location.assign(`${window.location.origin}/auth/login?login_hint=${login_hint}&redirectUri=${to.path}`);
                } else {
                    window.location.assign(`${window.location.origin}/auth/login?redirectUri=${to.path}`);    
                }
                
                return;
            }
        }
        
        // check authentication
        const isAuthenticated = await checkAuthentication(to);
        if (!isAuthenticated) {
            const isPaymentRoute = to.name === Payment.name;
            const isHomeRoute = to.name === Home.name;
            const hasVisited = useUserStore().visited();

            if (!isPaymentRoute && !isHomeRoute && !hasVisited) {
                return { path: '/public', replace: true };
            }

            redirectToLogin();
            return;
        }

        // check authorization
        await checkAuthorization(to);
    }
}

async function checkAuthentication(to: RouteLocation) {

    if (useUserStore().isAuthenticated) {
        return true;
    }

    return await useUserStore().isUserAuthenticated();
}

async function checkAuthorization(to: RouteLocation) {
    if (!useUserStore().isAuthenticated) {
        return false;
    }

    if (!useUserStore().userDataRetreived) {
        await useUserStore().loadUserData();
    }

    return true;
}